import { composedMap } from '../shape-map';
import { useChildIdSet } from './child-id-set-query';
import { resolveScope } from './audit-log-filters';

export default function useRecordScope({ recordRef, filters }) {
  const needsChildIdSet = Boolean(recordRef) && Boolean(filters.childType) && !filters.childId;
  const {
    ids: childIds,
    loading,
    error,
  } = useChildIdSet({
    parentId: recordRef?.scopeValues?.id,
    childType: needsChildIdSet ? filters.childType : null,
  });

  if (!recordRef) return { where: {}, loading, error };

  const scope = resolveScope({
    composedMap,
    recordRef,
    childType: filters.childType,
    childId: filters.childId,
    childIds,
  });

  return { where: scope.where, loading, error };
}
